import { SuperSource } from '@slite/search-client'

type SourceLogo = {
  source: SuperSource
  left: string
  top: string
  insight?: string
  scanIndex?: number
}

export const SOURCE_LOGOS: SourceLogo[] = [
  { source: SuperSource.ATTIO, left: '13%', top: '10%' },
  {
    source: SuperSource.SLACK_CHANNEL,
    left: '7%',
    top: '29%',
    scanIndex: 0,
    insight:
      'Big discussion around the new API, should be updated in the sprint doc.',
  },
  { source: SuperSource.HUBSPOT, left: '19%', top: '44%' },
  { source: SuperSource.ASANA, left: '6%', top: '61%' },
  {
    source: SuperSource.INTERCOM,
    left: '7%',
    top: '80%',
    scanIndex: 2,
    insight: 'Customer feedback demands a new tutorial.',
  },
  { source: SuperSource.LINEAR, left: '88%', top: '8%' },
  {
    source: SuperSource.GITHUB,
    left: '94%',
    top: '25%',
    scanIndex: 1,
    insight: 'PR #4332 merged, help center docs need an update.',
  },
  { source: SuperSource.JIRA, left: '81%', top: '41%' },
  { source: SuperSource.GOOGLE_DRIVE, left: '92%', top: '58%' },
  { source: SuperSource.MICROSOFT_SHAREPOINT, left: '25%', top: '80%' },
  { source: SuperSource.BIGQUERY, left: '71%', top: '86%' },
  {
    source: SuperSource.SLITE,
    left: '84%',
    top: '76%',
    scanIndex: 3,
    insight: 'New HR policy affects the holiday rules doc.',
  },
]

// The default scatter hugs the edges because the homepage centers its text in
// the box. Text-free embeds use this set: half the sources, spread evenly
// across the whole canvas with a clearing around the center orbit. Keeps the
// four scan-line insights plus two anchors so the loop still lands on tooltips.
const COMPACT_SOURCE_POSITIONS: Partial<
  Record<SuperSource, { left: string; top: string }>
> = {
  [SuperSource.ATTIO]: { left: '30%', top: '16%' },
  [SuperSource.SLACK_CHANNEL]: { left: '12%', top: '44%' },
  [SuperSource.INTERCOM]: { left: '20%', top: '78%' },
  [SuperSource.GITHUB]: { left: '90%', top: '14%' },
  [SuperSource.SLITE]: { left: '80%', top: '54%' },
  [SuperSource.BIGQUERY]: { left: '62%', top: '84%' },
}

export const COMPACT_SOURCE_LOGOS: SourceLogo[] = SOURCE_LOGOS.filter(
  (logo) => logo.source in COMPACT_SOURCE_POSITIONS
).map((logo) => ({ ...logo, ...COMPACT_SOURCE_POSITIONS[logo.source] }))
